export enum PaymentReasonCodes {
  GracePeriodApplied = 'GRACE_PERIOD_APPLIED',
}
